<template>
    <div class="photo-lower-bar-button-group">
        <div class="photo-lower-bar-button" v-on:click="confirm()">
            <SVGPhotoDelete class="lb-svg"/>
            <span class="photo-lower-bar-button-text extra-left-padding">Удалить</span>
        </div>
        <div class="photo-lower-bar-button" v-on:click="editSelectedDesign()" v-show="routeName === 'designListSelected'">
            <SVGAdminEditRow class="lb-svg"/>
            <span class="photo-lower-bar-button-text extra-left-padding">Редактировать дизайн</span>
        </div>
    </div>
</template>

<script>
    import SVGPhotoDelete from "../../SVG/SVGPhotoDelete";
    import SVGAdminEditRow from "../../SVG/SVGAdminEditRow";
    import ModalConfirmation from "../../Modal/ModalConfirmation";
    import SVGShadeOff from "../../SVG/SVGShadeOff";
    import SVGShadeOn from "../../SVG/SVGShadeOn";

    export default {
        name: "LeftLowerBarDeleteDesign",
        components: {
            SVGShadeOn,
            SVGShadeOff,
            SVGAdminEditRow,
            SVGPhotoDelete
        },
        computed: {
            routeName() {
                return this.$store.state.route.name;
            }
        },
        methods: {
            deleteSelectedDesign() {
                return async () => {
                    await this.$store.dispatch('active/DELETE_DESIGN_MODULE');
                    await this.$router.replace({name: 'designList'}).catch(() => {});
                }
            },
            editSelectedDesign() {
                this.$router.push({name: 'designMaterials'}).catch(() => {});
            },
            confirm() {
                const title = 'Удалить выбранный дизайн?'
                const text = 'Данный дизайн будет безвозвратно удалён! Вы уверены, что хотите продолжить?';
                this.$modal.show(ModalConfirmation, {title, text, alright: this.deleteSelectedDesign()}, {
                    name: 'confirmationModal',
                    height: 'auto',
                    pivotY: 0.2,
                    width: 460,
                    draggable: true,
                });
            }
        }
    }
</script>

<style scoped>

</style>
